import { useSelector } from "@tanstack/react-form";
import { TextInput, type TextInputProps } from "../../form-fields/components/text-input";
import { Stack } from "../../stack";
import { useFieldContext } from "../form/form-context";
import { FieldInfo } from "./fieldinfo";

type TextFieldProps = {
	label: string;
	type?: "number" | "text" | "email" | "password" | "tel";
	helperText?: string;
} & TextInputProps;

export const TextField = ({ label, type = "text", helperText, ...rest }: TextFieldProps) => {
	const field = useFieldContext<string>();
	const meta = useSelector(field.store, (state) => state.meta);
	return (
		<Stack gap={1}>
			<TextInput
				type={type}
				label={label}
				autoComplete="off"
				id={field.name}
				name={field.name}
				value={field.state.value}
				onBlur={field.handleBlur}
				onChange={(e) => field.handleChange(e.target.value)}
				error={meta.errors.length > 0}
				{...rest}
			/>
			<FieldInfo field={field} helperText={helperText} />
		</Stack>
	);
};
